import { Outlet, useRouterState } from '@tanstack/react-router'
import type { ReactNode } from 'react'

import { cn } from '@aeris/ui'

import { PageGate } from '../page-gate.tsx'

/**
 * O miolo de uma janela do Modo PC — F138.
 *
 * A mesma regra de enquadramento do shell e da janela nativa (F085): uma página
 * rola por dentro e respira num padding; um espaço de trabalho recebe a área
 * inteira e cuida da própria rolagem. `h-full` e não `100dvh`, porque a altura
 * é a da janela, e não a da página.
 *
 * Um `div` e não `<main>`: numa área de trabalho com seis janelas haveria seis
 * `<main>`, e a página tem um só conteúdo principal para o leitor de tela. Quem
 * nomeia cada janela é a moldura (`role="group"` com o título).
 *
 * Sem `RequireSession` aqui dentro, de propósito: a sessão já é conferida em
 * volta da área de trabalho inteira. Conferida de novo por janela, um "sair"
 * mandaria cada janela desenhar a tela de login dentro dela.
 */
export const WindowMain = (): ReactNode => {
  const chrome = useRouterState({
    select: (state) => state.matches.at(-1)?.staticData.chrome,
  })

  return (
    <div
      data-window-content=""
      // Focável: clicar num ponto vazio da janela precisa deixar o foco DENTRO
      // dela, senão o atalho da tela (F2 no PDV) não sabe de quem é a tecla.
      tabIndex={-1}
      className={cn(
        'h-full bg-(--surface-base)',
        chrome === 'workspace' ? 'overflow-hidden' : 'overflow-auto p-5'
      )}
    >
      <PageGate>
        <Outlet />
      </PageGate>
    </div>
  )
}
